module.exports = __webpack_public_path__ + "img/FROM-OLDMUTUAL-mobile.05fe9482.svg";